export default __webpack_public_path__ + "static/media/single-selected.be6e05af.svg";